import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">Our online conference is all about the latest AI tools for web designers,and we're bringing in TOP experts to give some killer talks and panel discussions. We've got over 10 speakers lined up, along with 3 panels, trending startup overviews, Q&A sessions, certificates, and some spicy conversations in the event chat.</p>
                            <p className="concept-text p1">Hey UI/UX designers, listen up - you can't work like you used to. You gotta use AI, or you're gonna lose out. And this ain't no boring online course - this is a community-generated conference with some seriously cool people sharing their emotions and best practices.</p>
                            <p className="concept-text p1">We're expecting over 1000 participants from all over the world, and it's gonna be a hot event from a powerful event organizer that's been killing it with over 50 events in the past three years. Our speakers come from the biggest brands, have won awards, and have fresh use cases to share.</p>
                            <p className='concept-text concept-text--bold p1'>So, if you wanna <span>stay on top of the freshest AI tools</span> in web design, then you gotta hit up our conference</p>
                            <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;